import store from "./StoreConfig";
import { logoutAction } from "./StoreActionConfig";
import { AppHttp } from "./HttpConfig";
import { getAppSubdomain } from "utils/GlobalUtils";

AppHttp.interceptors.request.use((config) => {
  const subdomain = getAppSubdomain();
  const { token } = store.getState().global[subdomain] || {};

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

AppHttp.interceptors.response.use(undefined, (error) => {
  if (
    error?.response?.status === 401 ||
    (error?.response?.status === 403 &&
      error?.response?.data?.message === "Token is invalid")
  ) {
    store.dispatch(logoutAction());
  }
  return Promise.reject(error);
});
